import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// material-ui
import ButtonBase from '@mui/material/ButtonBase';

// project imports
import LogoIcon from './LogoIcon';

import { APP_DEFAULT_PATH } from '@/config';
const baseSX = {
  display: 'flex',
  justifyContent: 'center'
}
// ==============================|| MAIN LOGO ||============================== //

export default function LogoSection({ reverse, isIcon, sx, to, logoScale = 1 }) {
  return (
    <ButtonBase disableRipple component={Link} to={to || APP_DEFAULT_PATH} sx={sx} aria-label="Logo">
      {isIcon ? <LogoIcon scale={logoScale}/> : <LogoIcon scale={logoScale} />}
    </ButtonBase>
  );
}

LogoSection.propTypes = { reverse: PropTypes.bool, isIcon: PropTypes.bool, sx: PropTypes.any, to: PropTypes.any, logoScale: PropTypes.number };
